<template>
    <div>
        <div class="cb">
            <span class="line fl"></span>
            <span class="fl dc">设置密码</span>
        </div>

        <div class="form" @keyup.enter="save">

            <div class="form-group old-box cb">
                <div class="old-title fl">新的密码</div>
                <input type="password" v-model="psw" :class="`old-phone fl${pswTip ? ' ol' : ''}`" @click="pswTip = ''">
            </div>
            <div class="form-message">{{pswTip}}</div>

            <div class="form-group old-box cb">
                <div class="old-title fl">确认密码</div>
                <input type="password" v-model="pswClone" :class="`old-phone fl${pswCloneTip ? ' ol' : ''}`" @click="pswCloneTip = ''">
            </div>
            <div class="form-message">{{pswCloneTip}}</div>

            <div class="form-group bg next cp" @click="save">
                <span v-show="!is_loading">保存设置</span>
                <span v-show="is_loading" class="next-box loading"></span>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        data: () => ({
            is_loading: false,
            psw: '',
            pswClone: '',
            pswTip: '',
            pswCloneTip: '',
        }),
        methods: {
            checkPsw() {
                if (this.psw.length < 6 || this.psw.length > 16) {
                    this.pswTip = '密码不能小于6个字符或大于16个字符';
                }
                if (this.psw !== this.pswClone) {
                    this.pswCloneTip = '两次密码不一致，请重新输入';
                }
            },
            error(e) {
                if (!e) return;
                let {status_code, message} = e;
                switch (status_code) {
                    case 1004: this.pswTip = message;break;
                    case 1007:
                        this.alert.err(message);
                        this.first = true;
                        break;
                    default:
                        this.alert.err(message);
                }
                this.is_sending = this.is_loading = false;// 取消发送验证码按钮的loading
            },
            save() {// 更换新密码
                this.checkPsw();

                if (this.pswTip || this.pswCloneTip || this.is_loading) return;

                this.is_loading = true;

                this.api.post('users/psw/bind', {psw: this.psw}).then(() => {
                    this.alert.suc('设置成功');
                    this.user.has_psw = true;
                    this.$router.push('/user');
                }, this.error);
            },
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
        },
        watch: {
            psw() {
                this.pswTip = '';
            },
            pswClone() {
                this.pswCloneTip = '';
            }
        },
    }
</script>

<style scoped>
    @import "../../../static/css/views/user/mod-phone.css";
</style>


// WEBPACK FOOTER //
// src/views/user/BindPsw.vue